import { render, staticRenderFns } from "./TouchScreenLoansList.vue?vue&type=template&id=59c68d82&scoped=true&"
import script from "./TouchScreenLoansList.vue?vue&type=script&lang=js&"
export * from "./TouchScreenLoansList.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreenLoansList.vue?vue&type=style&index=0&id=59c68d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c68d82",
  null
  
)

export default component.exports